<template src="./orchestrationEvents.template.html">
</template>
<script>
  import moment from 'moment';
  import * as axios from 'axios';
  import Vue from 'vue'


  import VirtualScroll from "../../reservations/reservationListVue/src/component/VirtualScroll.vue";
  import 'vue-virtual-infinite-scroll/dist/css/vue-virtual-infinite-scroll.css'
  import orchestrationEventItem from './orchestrationEventItem/orchestrationEventItem.vue';
  

  Vue.component('virtual-list', VirtualScroll)
  export default {
    name: "OrchestrationEvents",
    props: [],
    components: {
      orchestrationEventItem
    },
    data() {
      return {
        dateFormatToDisplay: 'utc',
        selectedOrchEventItem: {},
        orchestrationEventDetailPanel: false,
        orchestrationEventDetails: {},
        orchestrationEvents: [],
        openApiRequestLogs: [],
        showSourceList: false,
        showMessageTypeList: false,
        selectedFilterColumn: null,
        filterSourceText: '',
        filterMessageTypeText: '',
        minDate: null,
        maxDate: null,
        orchFilterDateRange: { startDate: null, endDate: null },
        dateFormat: 'DD MMM YYYY',
        linkedCalendars: null,
        filterObj: {
          Sources: [],
          MessageTypes: [],
          orchStartDate: null,
          orchEndDate: null
        },
        viewSaveObject: {
          Sources: [],
          MessageTypes: [],
        },
        sourcesList: [{SourceName: 'Tempo'}, {SourceName: 'Rentals United'}, {SourceName: 'SiteMinder'}, {SourceName: 'Stripe Connect'}, {SourceName: 'Booking Engine'}, {SourceName: 'Open API'}, {SourceName: 'Wheelhouse'}, {SourceName: 'Finalytic'}, {SourceName: 'Clearview Payments'}, {SourceName: 'Slim CD'}, {SourceName: 'QuickBooks'}, {SourceName: 'Airbnb'}],    
        messageTypesList: [{messageTypeName: 'Inventory'}, {messageTypeName: 'Property Sync'}, {messageTypeName: 'Rates'}, {messageTypeName: 'Res Cancel'}, {messageTypeName: 'Res Modification'}, {messageTypeName: 'Restrictions'}],
        items: [],
        options: {
          scrollbars: true,
          interactiveScrollbars: true,
          probeType: 3,
          mouseWheel: true,
          mouseWheelSpeed: 1
        },
        viewAttrsChanged: false,
        variable: false,
        totalLength: null,
        pullDownTextObj: {
          trigger: 'Loading...',
          begin: 'Loading...',
          complete: 'There are no items',
          error: 'There is server error',
          refresh: 'Loading...'
        },
        scrlBtns: false,
        scrllCount: 50,
        loading: true,
        isGreyOut: false,
        toggleFilterPanel: false,
        linearProgress: false,
        pageNumber: 1,
        itemsPerPage: 20,
      };
    },
    methods:{
      GetOrchestrationEventsFnc() {
        let vm = this;
        if (vm.items.length == 0) {
          vm.loading = true;
        }
        else if (vm.items.length > 0) {
          vm.loading = false;
        }
        vm.$store.dispatch("dataRequestHandler",
            {
            key: "GetOrchestrationEvents",
            params: {
              ModuleAction: "GetOrchestrationEvents",
              PageNumber: vm.pageNumber,
              PageSize: vm.itemsPerPage,
              Source:  vm.filterObj.Sources.map((each) => each.SourceName).join(','),
              MessageType:  vm.filterObj.MessageTypes.map((each) => each.messageTypeName).join(','),
              FromDate: vm.filterObj.orchStartDate,
              ToDate: vm.filterObj.orchEndDate
            },
            callback: function (err, response) {
                if (err) {
                    console.log('GetOrchestrationEvents error', err)
                    vm.loading = false;
                    return;
                }

                var itemsWrap = $("#tagScrollSection").width();
                var tagBtnGrp = $(".tagBtnGrp").width();
                var calcWidth = itemsWrap + 300;
                if (calcWidth >= tagBtnGrp) {
                  vm.scrlBtns = true;
                }
                else {
                  vm.scrlBtns = false;
                }

                if (response) {
                    console.log("GetOrchestrationEvents", response, response[0][0].TotalRecords);
                    vm.totalLength = response[0][0].TotalRecords;
                    if (vm.pageNumber === 1) {
                      let i = 1
                      let updateResponse = response[1].map(each => ({...each, index: i++ }))
                      vm.items.splice(0, vm.items.length, ...updateResponse);
                      console.log('vm.items', vm.items)
                      vm.$store.dispatch("toastr", {
                      type: "success",
                      header: "Success!",
                      message: "Rendered All Orchestration Events Successfully!"
                    });
                    }
                    else if (vm.pageNumber > 1) {
                      let indexCount = vm.items.length + 1;
                      let updateResponse = response[1].map(each => ({...each, index: indexCount++ }))
                      vm.items.splice(vm.items.length, 0, ...updateResponse);
                    }

                      console.log('vm.items', vm.items)

                    vm.loading = false;
                }
            }
        });
      },
      showFilterByType(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.selectedFilterColumn = filterCol;
          if (filterCol == "source") {
            $("#sourceDropDown").show();
          }else if (filterCol == "messageType") {
            $("#messageTypeListDropDown").show();
          }
        }, 10);
      },
      showSourceFnc() {
        this.showSourceList = true;
      },
      showMessageTypeListFnc() {
        this.showMessageTypeList = true;
      },
      removeSourceFromFilter(sourceObj, event) {
        let vm = this;
        var index = vm.filterObj.Sources.indexOf(sourceObj);
        if (index > -1) {
          vm.filterObj.Sources.splice(index, 1);
        }
        vm.sourcesList.push(sourceObj);
        if (event)
          event.stopPropagation();
      },
      removeMessageTypeFromFilter(messageTypeObj, event) {
        let vm = this;
        var index = vm.filterObj.MessageTypes.indexOf(messageTypeObj);
        if (index > -1) {
          vm.filterObj.MessageTypes.splice(index, 1);
        }
        vm.messageTypesList.push(messageTypeObj);
        if (event)
          event.stopPropagation();
      },
      removeSelectedOrchDatesFromFilter(filterObj) {
        filterObj.orchStartDate = null,
        filterObj.orchEndDate = null,
        this.orchFilterDateRange.startDate = null,
        this.orchFilterDateRange.endDate = null,
        this.applyFilter();
      },
      deleteSelectedSourceFromFilter(index, sourceObj) {
        this.removeSourceFromFilter(sourceObj);
        this.viewSaveObject.Sources.splice(index, 1);
        this.applyFilter();
      },
      deleteSelectedMessageTypeFromFilter(index, msgTypeObj) {
        this.removeMessageTypeFromFilter(msgTypeObj);
        this.viewSaveObject.MessageTypes.splice(index, 1);
        this.applyFilter();
      },
      updateOrchestrationFilterDateValues(value) {
        this.filterObj.orchStartDate = moment(value.startDate).format('DD MMM YYYY')
        this.filterObj.orchEndDate = moment(value.endDate).format('DD MMM YYYY')
      },
      addSourceToFilter(sourceObj) {
        let vm = this;
        vm.filterObj.Sources.push(sourceObj);
        vm.filterSourceText = '';
        var index = vm.sourcesList.indexOf(sourceObj);
        if (index > -1) {
          vm.sourcesList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      addMessageTypeToFilter(msgTypeObj) {
        let vm = this;
        vm.filterObj.MessageTypes.push(msgTypeObj);
        vm.filterMessageTypeText = '';
        var index = vm.messageTypesList.indexOf(msgTypeObj);
        if (index > -1) {
          vm.messageTypesList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      scrollRight: function () {
        var container = this.$el.querySelector("#tagScrollSection");
        var cnt = this.scrllCount++;
        container.scrollLeft = cnt;
        console.log("scroll counter before" + cnt);
        this.scrllCount = this.scrllCount + 50;
        console.log("scroll counter after" + cnt);
        this.scrollLeft = cnt;


      },
      scrollLeft: function () {

        var container = this.$el.querySelector(".scrollingTags");
        console.log("Inner width -" + container.clientWidth);
        if (this.scrllCount == -1) {
          var container = this.$el.querySelector("#tagScrollSection");
          container.scrollLeft = 0;
          console.log("If");
        } else {
          var container = this.$el.querySelector("#tagScrollSection");
          var cnt2 = this.scrllCount--;
          container.scrollLeft = cnt2;
          console.log("scroll counter before" + cnt2);
          this.scrllCount = this.scrllCount - 50;
          console.log("scroll counter after" + cnt2);
        }
      },
      showOrchestrationEventDetailPanel(eachEventData){
        let vm=this;
        vm.orchestrationEventDetails = eachEventData;
        this.orchestrationEventDetailPanel = true;
        vm.selectedOrchEventItem = eachEventData;

      },
      getMoreData($stateChange) {
        console.log('getMoreData is called')
        if (this.items.length >= this.totalLength) {
          $stateChange('complete')
        } else {
          setTimeout(() => {
            $stateChange('loaded')
          }, 1500)
          this.loading = false;
          this.pageNumber++;
          this.GetOrchestrationEventsFnc();
        }
      },
      refreshData($pullStateChange) {
        console.log('refreshData is calling');
        setTimeout(() => {
          this.items.splice(0)
          for (let i = 0; i < 50; i++) {
            this.items.push({
              text: i,
              id: i,

            })
          }
          $pullStateChange('complete')
        }, 1500)
      },
      refreshBtnClicked() {
        let vm = this
        vm.items = [];
        vm.pageNumber = 1;
        let refreshBtnEl = document.getElementById('refreshBtn')
        refreshBtnEl.classList.add('btn-default-refresh1')

        setTimeout(() => {
          console.log('refreshBtnEl', refreshBtnEl)
          refreshBtnEl.classList.remove('btn-default-refresh1')
        }, 500)
        vm.GetOrchestrationEventsFnc()
      },
      formattedDate(dateString) {
        if (dateString) {
          return moment.utc(dateString).format('DD MMM YYYY hh:mm:ss A')
        }
        return null
      },
      applyFilter() {

        let vm = this;

        vm.items = [];
        vm.pageNumber = 1;
        vm.toggleFilterPanel = false;
        vm.showSourceList = false;
        vm.showMessageTypeList = false;
        vm.viewSaveObject.Sources.splice(0, vm.viewSaveObject.Sources.length, ...vm.filterObj.Sources);
        vm.viewSaveObject.MessageTypes.splice(0, vm.viewSaveObject.MessageTypes.length, ...vm.filterObj.MessageTypes);
        if (vm.viewSaveObject.Sources.length > 1 || vm.viewSaveObject.MessageTypes.length > 1) {
          vm.viewAttrsChanged = true;
        } else {
          vm.viewAttrsChanged = false;
        }
        vm.GetOrchestrationEventsFnc();

      },
  
      selectColumn(column, event) {
        let vm = this;
      },

      closeFilter() {
        let vm = this;
        vm.toggleFilterPanel = false;
        vm.orchestrationEventDetailPanel=false
        vm.showSourceList = false;
        vm.showMessageTypeList = false;
      },

      clearAllFilters() {
        this.items = [];
        this.scrlBtns = false;
        this.viewAttrsChanged = false;
        this.showSourceList = false;
        this.showMessageTypeList = false;
        this.sourcesList = [{SourceName: 'Tempo'}, {SourceName: 'Rentals United'}, {SourceName: 'SiteMinder'}, {SourceName: 'Stripe Connect'}, {SourceName: 'Booking Engine'}, {SourceName: 'Open API'}, {SourceName: 'Wheelhouse'}, {SourceName: 'Finalytic'}, {SourceName: 'Clearview Payments'}, {SourceName: 'Slim CD'}, {SourceName: 'QuickBooks'}, {SourceName: 'Airbnb'}];
        this.messageTypesList = [{messageTypeName: 'Inventory'}, {messageTypeName: 'Property Sync'}, {messageTypeName: 'Rates'}, {messageTypeName: 'Res Cancel'}, {messageTypeName: 'Res Modification'}, {messageTypeName: 'Restrictions'}];
        this.filterObj = {
          Sources: [],
          MessageTypes: [],
          orchStartDate: null,
          orchEndDate: null
        };

        this.viewSaveObject = {
          Sources: [],
          MessageTypes: [],
        },
        this.pageNumber = 1;
        this.itemsPerPage = 20;
        // after clearing the filters passing the date range as current day
        this.orchFilterDateRange.startDate = new Date(); 
        this.orchFilterDateRange.endDate = new Date();

        this.GetOrchestrationEventsFnc();
      }
    },
    computed: {
      filteredSourcesList() {
        let filteredList = this.sourcesList.filter(each => each.SourceName.toLowerCase().includes(this.filterSourceText.toLowerCase()));
        return filteredList
      },
      filteredMessageTypesList() {
        let filteredList = this.messageTypesList.filter(each => each.messageTypeName.toLowerCase().includes(this.filterMessageTypeText.toLowerCase()));
        return filteredList
      }
    },
    watch: {
      items(newArr, oldArr) {
        console.log("items changed", oldArr, newArr);
      },
      dateFormatToDisplay() {
        this.loading = true; // Set loading to true
        setTimeout(() => {
          this.loading = false; // Set loading to false after 500ms
        }, 300); // 500ms delay
      },
    },
    mounted() {
      let vm = this;
      vm.GetOrchestrationEventsFnc();
      $(this.$el).find("ul.dropdown-menu").click(function (e) {
        e.stopPropagation();
      });
      $(document).click(function (e) {
        $(".form-control.searchResultsAmenities").hide();
        vm.selectedFilterColumn = null;
      })
    },
    beforeDestroy() {
     
    }
  };
</script>

<style scoped>
.dateFormatSelect{
  width:fit-content;
  display: inline !important;
}
</style>